import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const sections = [
  {
    title: "Éditeur du site",
    content: [
      { label: "Raison sociale", value: "KS BTP" },
      { label: "Forme juridique", value: "SAS (Société par Actions Simplifiée)" },
      { label: "Capital social", value: "15 000 €" },
      { label: "SIREN", value: "908 316 607" },
      { label: "SIRET", value: "908 316 607 00021" },
      { label: "Code APE", value: "4399A" },
      { label: "Adresse du siège social", value: "9 rue de Lamirault, 77090 Collégien" },
      { label: "Téléphone", value: "01 75 43 43 46" },
      { label: "Email", value: "contact@ksbtp.fr" },
    ],
  },
  {
    title: "Dirigeants",
    content: [
      { label: "Gérant", value: "Mamby Keita" },
      { label: "Directeur d'Exploitation", value: "Edgar Vignon" },
      { label: "Directeur Travaux", value: "Ismael Soulama" },
    ],
  },
  {
    title: "Hébergement",
    content: [
      { label: "Hébergeur", value: "Readdy.ai" },
      { label: "Site", value: "https://readdy.ai" },
    ],
  },
];

const legalTexts = [
  {
    title: "Propriété intellectuelle",
    body: "L'ensemble du contenu de ce site (textes, images, graphismes, logo, icônes, sons, logiciels…) est la propriété exclusive de KS BTP, à l'exception des marques, logos ou contenus appartenant à d'autres sociétés partenaires ou auteurs. Toute reproduction, distribution, modification, adaptation, retransmission ou publication, même partielle, de ces différents éléments est strictement interdite sans l'accord exprès par écrit de KS BTP.",
  },
  {
    title: "Responsabilité",
    body: "KS BTP s'efforce d'assurer au mieux de ses possibilités l'exactitude et la mise à jour des informations diffusées sur ce site. Cependant, KS BTP ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site. En conséquence, KS BTP décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur ce site.",
  },
  {
    title: "Données personnelles",
    body: "Conformément à la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés, et au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant. Pour exercer ce droit, veuillez nous contacter à l'adresse : contact@ksbtp.fr.",
  },
  {
    title: "Cookies",
    body: "Ce site peut utiliser des cookies pour améliorer l'expérience utilisateur. En naviguant sur ce site, vous acceptez l'utilisation de cookies conformément à notre politique de confidentialité. Vous pouvez désactiver les cookies dans les paramètres de votre navigateur.",
  },
  {
    title: "Droit applicable",
    body: "Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.",
  },
];

export default function MentionsLegalesPage() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />

      {/* Hero */}
      <section className="pt-32 pb-16 bg-[#f5fdf8] border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-[#00a340] font-medium mb-6 hover:underline cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            Retour à l&apos;accueil
          </Link>
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Mentions <span className="text-[#00a340]">légales</span>
          </h1>
          <p className="text-gray-500 text-base">
            Conformément aux dispositions de la loi n°2004-575 du 21 juin 2004 pour la confiance en l&apos;économie numérique.
          </p>
        </div>
      </section>

      {/* Content */}
      <main className="flex-1 py-16">
        <div className="max-w-4xl mx-auto px-4 md:px-8 flex flex-col gap-12">

          {/* Info tables */}
          {sections.map((section) => (
            <div key={section.title}>
              <h2 className="text-xl font-extrabold text-gray-900 mb-5 pb-3 border-b-2 border-[#00a340]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {section.title}
              </h2>
              <div className="rounded-xl border border-gray-100 overflow-hidden">
                {section.content.map((row, i) => (
                  <div
                    key={row.label}
                    className={`flex flex-col sm:flex-row ${i % 2 === 0 ? "bg-white" : "bg-[#f5fdf8]"} px-6 py-4 gap-1 sm:gap-4`}
                  >
                    <span className="text-sm font-semibold text-gray-500 sm:w-56 flex-shrink-0">{row.label}</span>
                    <span className="text-sm text-gray-800 font-medium">{row.value}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* Legal text sections */}
          {legalTexts.map((section) => (
            <div key={section.title}>
              <h2 className="text-xl font-extrabold text-gray-900 mb-4 pb-3 border-b-2 border-[#00a340]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {section.title}
              </h2>
              <p className="text-gray-600 text-sm leading-relaxed">{section.body}</p>
            </div>
          ))}

          {/* Contact CTA */}
          <div className="rounded-2xl bg-[#f5fdf8] border border-[#c8f0d8] p-8 flex flex-col sm:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-lg font-extrabold text-gray-900 mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Une question ?
              </h3>
              <p className="text-gray-500 text-sm">Contactez-nous directement pour toute demande d&apos;information.</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
              <a
                href="tel:0175434346"
                className="px-5 py-2.5 rounded-lg border border-[#00a340] text-[#00a340] text-sm font-semibold whitespace-nowrap hover:bg-[#00a340] hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                01 75 43 43 46
              </a>
              <a
                href="mailto:contact@ksbtp.fr"
                className="px-5 py-2.5 rounded-lg bg-[#00a340] text-white text-sm font-semibold whitespace-nowrap hover:bg-[#007a30] transition-colors cursor-pointer"
              >
                <i className="ri-mail-line mr-2"></i>
                contact@ksbtp.fr
              </a>
            </div>
          </div>

        </div>
      </main>

      <Footer />
    </div>
  );
}
